<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div :class="['IM_1_' + this.id]">
    <div id="mapid"></div>
    <div class="leaflet-top leaflet-right">
      <b-button variant="light" id="goback" onclick="go_back()">Retour au dernier point</b-button>
    </div>
    <div class="leaflet-top leaflet-left boussole">
      <img src="https://cdn.exploreve.fr/content/carte/rosedesvents.svg" />
    </div>
    <div v-on:click="display_bag = !display_bag" class="sac">
      <img src="https://cdn.exploreve.fr/content/sac_a_dos/sac_a_dos.svg" alt />
    </div>

    <div v-show="display_bag">
      <div class="contenu">
        <div v-on:click="display_bag = !display_bag" class="close">X</div>
        <h3>Sac à dos</h3>
        <div textalign="left">
          <a href="https://cdn.exploreve.fr/content/sac_a_dos/codex.pdf" target="_blank">- Codex</a>
          <br />
          <a href="https://cdn.exploreve.fr/content/sac_a_dos/parchemin_exploreve.pdf" target="_blank"
            >- Parchemin de l'explorêve</a
          >
        </div>
      </div>
      <div class="arrow"></div>
    </div>

    <audio id="music2" loop>
      <source src="https://cdn.exploreve.fr/content/music/musique_2.mp3" />
    </audio>
    <audio id="music3" loop>
      <source src="https://cdn.exploreve.fr/content/music/musique_3.mp3" />
    </audio>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  components: {},
  name: "IM_1_5",
  data: function () {
    return {
      id: 5,
      display_bag: false
    };
  },
  mounted() {
    let customScript = document.createElement("script");
    customScript.setAttribute("src", "../mapscript.js");
    document.head.appendChild(customScript);
  }
};
</script>

<style lang="scss">
.close {
  color: black;
  margin: 5px;
  cursor: pointer;
}

.sac {
  position: absolute;
  margin: 15px;
  bottom: 15px;
  left: 15px;
  cursor: pointer;
  img {
    height: 10vh;
  }
}

.contenu {
  position: absolute;
  width: 280px;
  height: 100px;
  bottom: 120px;
  background-color: #eecea1;
  border-radius: 20px;
  margin: 30px;
  z-index: 1;
}

.arrow {
  content: "";
  position: absolute;
  bottom: 120px;
  left: 60px;
  width: 0px;
  height: 0px;
  border-style: solid;
  border-width: 40px 40px 0px 0px;
  border-color: #eecea1 transparent transparent transparent;
}

.testcarte {
  width: 100%;
  height: 100%;
}
#mapid {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  z-index: 0;
}
#goback {
  cursor: pointer;
  pointer-events: auto;
  margin: 80px 10px;
}

.boussole {
  margin: 80px 10px;
  img {
    height: 15vh;
  }
}

.leaflet-popup {
  width: 40vw;
  left: -20vw !important;
}
.leaflet-popup-content {
  width: auto !important;
}
#popup {
  font-family: "Faune";
  font-size: 13pt;
}
#citation {
  font-family: "Faune";
  font-style: italic;
  font-size: 13pt;
  margin-left: 32px;
  border-left: 4px solid #ccc;
  padding-left: 8px;
  user-select: none;
}
#popuptitle {
  font-family: "Faune";
  font-style: bold;
  font-size: 14pt;
}
#media {
  display: block;
  margin: auto;
  max-height: 25vh;
}
#boussole {
  display: block;
  margin: auto;
  max-height: 35vh;
}
p #transcription {
  display: block;
  font-size: 12pt;
  margin: auto;
  text-align: center;
}
h2 {
  font-family: "Faune";
  font-weight: 600;
}
</style>
